// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_-1_","controls":"styles_controls__cbA04","charLimit":"styles_charLimit__3aheV","input":"styles_input__3Tqk2","send":"styles_send__2kYXy"};